// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  Fragment,
} from 'react';

import { Colors } from '@zapier/design-system';
import { Spacing } from '@zapier/theme';
/** @jsx jsx */
import { jsx } from '@emotion/core';

import type { Alert } from '../types';

type Props = {
  alert: ?Alert,
};

const stackCss = {
  fontSize: '70%',
  opacity: '75%',
};

const OverlayMessageLine = ({ line }) => (
  <Fragment>
    {line}
    <br />
  </Fragment>
);

const renderMessage = (message: string) =>
  message &&
  message
    .split('\n')
    .filter(line => line.length > 0)
    .map((line, index) => <OverlayMessageLine key={index} line={line} />);

const Overlay = ({ alert }: Props) => {
  const backgroundColor = Colors.blue500;
  const color = Colors.white;
  const padding = Spacing.medium;

  const overlayContainerCss = {
    backgroundColor,
    opacity: 0.99,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    height: '100%',
    width: '100%',
    zIndex: 100000000,
  };

  const overlayCss = {
    opacity: 1.0,
    color,
    maxWidth: '100%',
    overflow: 'auto',
    padding,
  };

  const headerCss = {
    color,
  };

  return (
    alert && (
      <div css={overlayContainerCss}>
        <div css={overlayCss}>
          <h1 css={headerCss}>Performance Problem Detected</h1>
          <p>
            <strong>{renderMessage(alert.message)}</strong>
          </p>
          <pre css={stackCss}>{alert.stack}</pre>
        </div>
      </div>
    )
  );
};
export default Overlay;
